import { render, staticRenderFns } from "./buy-order-code.vue?vue&type=template&id=67cdbd02&scoped=true"
import script from "./buy-order-code.vue?vue&type=script&lang=js"
export * from "./buy-order-code.vue?vue&type=script&lang=js"
import style0 from "./buy-order-code.vue?vue&type=style&index=0&id=67cdbd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cdbd02",
  null
  
)

export default component.exports